const typeAffichageCoordonnees = [
  {
    id: "X_Y",
    libelle: "X et Y",
  },
  {
    id: "DEGRES_DECIMAUX",
    libelle: "Dégrés décimaux",
  },
  {
    id: "DEGRES_SEXAGESIMAUX",
    libelle: "Dégrés sexagésimaux",
  },
];

export const enum TYPE_AFFICHAGE_COORDONNEES {
  X_Y = "X_Y",
  DEGRES_DECIMAUX = "DEGRES_DECIMAUX",
  DEGRES_SEXAGESIMAUX = "DEGRES_SEXAGESIMAUX",
}

export default typeAffichageCoordonnees;
